import { useMemo } from 'react'
import type { Appearance } from '@stripe/stripe-js'
import { useDashboardTheme } from '@/contexts/DashboardThemeContext'

export function useStripeAppearance () {
  const { mode } = useDashboardTheme()
  return useMemo<Appearance>(() => {
    if (mode === 'light') return { theme: 'stripe' }
    const styles = getComputedStyle(document.documentElement)
    const color = (name: string) => styles.getPropertyValue(`--color-${name}`).trim()
    return {
      theme: 'night',
      variables: {
        colorPrimary: color('primary'),
        colorBackground: color('surface'),
        colorText: color('text'),
        colorTextSecondary: color('text-secondary'),
        colorTextPlaceholder: color('text-muted'),
        colorDanger: color('danger-text'),
        borderRadius: '8px'
      },
      rules: {
        '.Input': { borderColor: color('border-strong'), boxShadow: 'none' },
        '.Input:focus': { borderColor: color('primary') },
        '.Tab': { borderColor: color('border-strong'), boxShadow: 'none' },
        '.Tab--selected': { borderColor: color('primary') }
      }
    }
  }, [mode])
}
